import type { ApiResponse, Order } from '@cracked-mug/shared';
import { api } from './api';

function unwrap<T>(payload: ApiResponse<T>): T {
  if (!payload.success) {
    throw new Error(payload.error);
  }
  return payload.data;
}

/**
 * Submit a Square payment for an order. In sandbox mode the server returns
 * a mock paymentId — pass `sourceId: 'cnon:mock'`. Real card tokenization
 * via the Square Web Payments SDK is wired up in Phase 7.
 */
export async function createSquarePayment(args: {
  orderId: string;
  sourceId: string;
}): Promise<Order> {
  const res = await api.post<ApiResponse<Order>>('/square/create-payment', args);
  return unwrap(res.data);
}
